export default [
  {
    // 4-1
    path: "/ScienceCarrier/TechIncubato",
    name: "TechIncubato",
    component: () => import("../views/ScienceCarrier/TechIncubato"),
  },
  {
    // 4-2
    path: "/ScienceCarrier/MakerSpace",
    name: "MakerSpace",
    component: () => import("../views/ScienceCarrier/MakerSpace"),
  },
  {
    // 4-3
    path: "/ScienceCarrier/StarWorld",
    name: "StarWorld",
    component: () => import("../views/ScienceCarrier/StarWorld"),
  },
  {
    // 4-5
    path: "/ScienceCarrier/WisdomIsland",
    name: "WisdomIsland",
    component: () => import("../views/ScienceCarrier/WisdomIsland"),
  },
];
